export default [
  {
    itemName: "Bilet lotniczy zagraniczny ",
    documentNumber: "13/01/2021/RZE",
    documentItemIndex: "1",
    netValue: 373.99,
    purchaseNetPrice: 0.0,
    profit: 373.99,
    gross: 373.99,
  },
];
